import { RocketLaunchOutlined, TimerOutlined } from 'components/icons';
import { LineTab, LineTabs, LineTabsList } from 'components/LineTabs';
import { TabsContent } from 'components/ui/tabs';
import { useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { DashboardForm, DashboardHoursTab } from 'types/dashboard';
import { cn } from 'utils/cn';
import FinalizedHours from './finalized-hours/FinalizedHours';
import { PANEL_INSET } from './finalized-hours/util';
import ProgressTracking from './progress-tracking/ProgressTracking';

/**
 * The Finalised hours card with the Progress tracking tab beside it. One fixed height for every tab
 * and state, so switching tabs or loading never resizes the dashboard column.
 */
const HoursCard = () => {
    const { control, setValue } = useFormContext<DashboardForm>();
    const tab = useWatch({ control, name: 'hoursTab' }) ?? 'finalized-hours';
    // Mounted from its first visit on: the current employee is not cached once unsubscribed, so a remount
    // would refetch it on every switch back.
    const [progressVisited, setProgressVisited] = useState(tab === 'progress-tracking');

    return (
        <LineTabs
            value={tab}
            onValueChange={(value: DashboardHoursTab) => {
                setValue('hoursTab', value);
                if (value === 'progress-tracking') {
                    setProgressVisited(true);
                }
            }}
            className="bg-paper border-divider flex h-[350px] flex-col overflow-hidden rounded-lg border"
        >
            <LineTabsList>
                <LineTab value="finalized-hours" icon={<TimerOutlined className="size-4" />}>
                    <FormattedMessage id="dashboard.finalized-hours" />
                </LineTab>
                <LineTab value="progress-tracking" icon={<RocketLaunchOutlined className="size-4" />}>
                    <FormattedMessage id="dashboard.progress-tracking.title" />
                </LineTab>
            </LineTabsList>
            <TabsContent value="finalized-hours" className={cn('min-h-0 overflow-y-auto pb-4', PANEL_INSET)}>
                <FinalizedHours embedded />
            </TabsContent>
            <TabsContent value="progress-tracking" keepMounted={progressVisited} className="min-h-0">
                <ProgressTracking />
            </TabsContent>
        </LineTabs>
    );
};

export default HoursCard;
